<template>
  <div>
    <div v-if="disabled && showList" :class="className">
      <div class="spaceLeft" v-for="(item, index) in showList" :key="index">
        <div class="ellipsis" style="flex: 1">
          {{ item && (item.fileNm || item.name) }}
        </div>
        <svg
          class="icon img-icon"
          aria-hidden="true"
          @click="downFile(item)"
          style="margin-left: 10px; color: #096dd9"
          title="下载"
        >
          <use xlink:href="#gold-icon-xiazai"></use>
        </svg>
        <!-- <a-icon type="cloud-download" @click="downFile(item)" style="margin-left:10px;color:#096dd9;" /> -->
      </div>
    </div>
    <div v-else :class="className">
      <a-upload
        v-show="hideButtonHasFiles ? fileList.length == 0 : true"
        :accept="accept"
        :multiple="limit > 1"
        :file-list="fileList"
        :before-upload="beforeFileUpload"
        :remove="handleFileRemove"
        :customRequest="handleFileUpload"
        :disabled="disabled || fileList.length >= limit"
        :showUploadList="false"
      >
        <a-button class="spaceLeft" style="color: #1990ff">
          <svg class="icon img-icon" aria-hidden="true">
            <use xlink:href="#gold-icon-shangchuan"></use></svg
          >上传文件
        </a-button>
      </a-upload>
      <div class="file-list">
        <div
          class="spaceLeft file-list-item"
          v-for="item in fileList"
          :key="item.uid"
        >
          <div class="ellipsis" style="flex: 1">{{ item.name }}</div>
          <a-icon
            type="delete"
            @click="handleFileRemove(item)"
            style="margin-left: 10px; color: #ef763c"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fileDeletAPI } from "@/api/file.js";
export default {
  name: "fileUpload",
  props: {
    accept: {
      type: String,
      required: false,
      default: function () {
        return ".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.pdf,.PDF,.zip,.ZIP,.rar,.RAR,.doc,.docx,.xls,.xlsx,.ppt,.pptx";
      },
    },
    multiple: {
      type: Boolean,
      required: false,
      default: function () {
        return true;
      },
    },
    url: {
      type: String,
      required: false,
      default() {
        return "/gb-bigtree-file/fileUpload";
      },
    },
    // 可传入接口需要的参数
    paramObj: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    name: {
      type: String,
      required: true,
    },
    downUrl: {
      type: String,
      required: false,
      default: function () {
        return "";
      },
    },
    downName: {
      type: String,
      required: false,
      default: function () {
        return "空白模板.xlsx";
      },
    },
    limit: {
      type: [String, Number],
      required: false,
      default: function () {
        return 1;
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    showList: {
      //只读时的展示文件
      type: [Array],
      required: false,
      default: function () {
        return [];
      },
    },
    removeaction: {
      //删除时是否删除服务器文件
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    // 自定义class
    className: {
      type: [String],
      required: false,
    },
    // 已上传文件时，隐藏上传按钮
    hideButtonHasFiles: {
      type: [Boolean],
      required: false,
    },
  },
  data() {
    return {
      fileList: [],
      fileListCur: [],
      uploading: false,
      paramObjSelf: this.utils.deepClone(this.paramObj),
    };
  },
  computed: {},
  watch: {
    showList: {
      immediate: true,
      handler: function (val) {
        if (val[0]) {
          this.fileList = val.map((item) => {
            return {
              ...item,
              name: item.name || item.fileNm,
              uid: item.uid || item.fileId,
            };
          });
          this.fileListCur = this.fileList
        } else {
          this.fileList = [];
          this.fileListCur= []
        }
      },
    },
  },
  methods: {
    beforeFileUpload(file) {
      if (file.name && file.name.indexOf(".") > -1) {
        let d_name = file.name.substring(file.name.lastIndexOf(".") + 1);
        if (this.accept.indexOf(d_name) > -1) {
          this.fileListCur = [file];
          this.$emit("beforeFileUpload", this.fileList);
        } else {
          this.$message.error("请上传" + this.accept + "格式的文件");
          return false;
        }
      } else {
        this.$message.error("请上传" + this.accept + "格式的文件");
        return false;
      }
    },
    handleFileRemove(file) {
      const index = this.fileList.indexOf(file);
      this.fileList.splice(index, 1);
      this.$emit("remove", this.fileList);
      if (this.removeaction) {
        const params = {
          fileRte: file.fileRte,
          fileNm: file.name,
          fileExpdNm: file.fileExpdNm,
          fileSize: file.fileSize,
          tblBlId: file.tblBlId,
          fileId: file.fileId,
          fileTpCd: file.fileTpCd,
          fileSubTpCd: file.fileSubTpCd,
        };
        fileDeletAPI(params)
          .then((res) => {
            this.$emit("handleFileRemove", this.fileList);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$emit("handleFileRemove", this.fileList);
      }
    },
    handleFileUpload() {
      const formData = new FormData();
      this.fileListCur.forEach((file) => {
        formData.append(this.name, file);
        for (let key in this.paramObjSelf) {
          formData.append(key, this.paramObjSelf[key]);
        }
      });
      this.uploading = true;
      this.axios({
        url: this.url,
        data: formData,
        isTransform: false,
      })
        .then((res) => {})
        .catch((data) => {
          this.uploading = false;
          if (data[0]) {
            this.fileList.push({
              name: this.fileListCur[0].name,
              size: this.fileListCur[0].size,
              uid: this.fileListCur[0].uid,
              fileExpdNm: data[0].contentType,
              fileRte: JSON.parse(data[0].savePath).file,
              tblBlId: this.paramObjSelf.tblBlId,
              fileTpCd: this.paramObjSelf.fileTpCd,
              fileSubTpCd: this.paramObjSelf.fileSubTpCd,
            });
            this.$emit("uploadOk", this.fileList, this.paramObjSelf);
          }
        });
    },
    setParams(data) {
      this.paramObjSelf = data;
    },
    setFileList(item) {
      if (item) {
        this.fileList.push(item);
      } else {
        this.fileList = [];
      }
    },
    downFile(item) {
      const DOWNLOAD_PREFIX = "/gb-bigtree-file/download/fileDownload/install";
      window.open(
        `${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`,
        "_blank"
      );
    },
  },
  created() {
  },
};
</script>
<style scoped lang="less">
.ant-upload.ant-upload-disabled .ant-btn {
  cursor: no-drop;
  background: #f5f5f5;
}
.img-icon {
  font-size: 18px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/file-upload/file-upload.vue